export const sessionData = [
  {
    id: 1,
    title: 'Summer Session',
    dates: 'July 7 - August 15',
    time: 'Mon/Wed 6:00-8:00 PM PT'
  }
]; 